<template>
    <v-layout>
        <v-flex>
            <v-card style="width: 50%; margin: auto;">
              <v-card-title class="white--text tertiary">
                <h1>Verify Your Email Address</h1>
              </v-card-title>
              <v-card-text>
                <div v-if="verified">
                    <h3>Your email address "{{ email }}" has been verified!</h3>
                    <p>You will be redirected to the portal in 10 seconds. Otherwise, you can close this window.</p>
                </div>
                <div else>
                    <h3>An error occurred while verifying email address, please contact support at customerportal@danielshealth.ca</h3>
                </div>
                <p class="red--text">If you did not request this email verification, please contact support at customerportal@danielshealth.ca</p>
              </v-card-text>
              <v-card-actions>
              </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>    
</template>

<script>
export default {
    name: "VerifyEmail",
    data() {
        return {
            email: null
        }
    }
}
</script>

<style scoped>

</style>